import PropTypes from 'prop-types';
import { Box } from '@rebass/grid';

import { ContentWrapperSt } from './Section.css';

export const Section = ({
  children,
  backgroundColor,
  id,
  py,
  px,
  $maxWidth,
}) => (
  <Box as="section" px={px} py={py} bg={backgroundColor} id={id}>
    <ContentWrapperSt $maxWidth={$maxWidth}>{children}</ContentWrapperSt>
  </Box>
);

Section.defaultProps = {
  backgroundColor: 'white',
  id: '',
  py: [32, 64],
  px: [24, 28, 36, 156],
  $maxWidth: 968,
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
  id: PropTypes.string,
  px: PropTypes.array,
  py: PropTypes.array,
  $maxWidth: PropTypes.number,
};
